export const FETCH_TRANSACTIONS_LIST = 'FETCH_TRANSACTIONS_LIST';
export const FETCH_TRANSACTIONS_LIST_SUCCESS = 'FETCH_TRANSACTIONS_LIST_SUCCESS';
export const FETCH_TRANSACTIONS_LIST_FAILURE = 'FETCH_TRANSACTIONS_LIST_FAILURE';
export const CLEAR_TRANSACTIONS_LIST = 'CLEAR_TRANSACTIONS_LIST';
